import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import Pagination from "../Pagination/Paginations.js";
import EntriesSelector from "../Pagination/EntriesSelector";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";
import "../preloading.css";
import Select from 'react-select';

const AttendanceHistoryReport = () => {
  const today = new Date().toISOString().split("T")[0];

  const [filters, setFilters] = useState({
    start_date: today,
    end_date: today,
    dept_id: "0",
    employee_id: "0",
    action_type: "Fetch",
  });

  const [departments, setDepartments] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  // ✅ Handle input changes
  const handleInput = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Fetch Departments
  const fetchDepartments = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/showdepartment", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      const data =
        res.data.departments || res.data.data || (Array.isArray(res.data) ? res.data : []);
      setDepartments(data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load departments");
    }
  };

  // ✅ Fetch Employees based on Department
  const fetchEmployees = async (deptId) => {
    try {
      const res = await axios.get(API_BASE_URL + `/employees-by-dept/${deptId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      setEmployees(res.data.employees || res.data.data || []);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load employees");
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  useEffect(() => {
    if (filters.dept_id && filters.dept_id !== "0") {
      fetchEmployees(filters.dept_id);
    } else {
      setEmployees([]);
    }
  }, [filters.dept_id]);

  // ✅ Fetch Attendance History
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(
        API_BASE_URL + "/attn_history_report",
        {
          start_date: filters.start_date,
          end_date: filters.end_date,
          dept_id: filters.dept_id,
          employee_id: filters.employee_id,
          action_type: filters.action_type,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
      );

      if (filters.action_type === "Download") {
        toast.info("Download initiated...");
        // Optional: handle file download if backend returns a link
      } else {
        setRecords(res.data.records || []);
        setCurrentPage(1);
toast.success("Attendance history loaded!!", {
  position: "bottom-right",
});      }
    } catch (err) {
      console.error(err);
      toast.error("Error fetching attendance history");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Search & Pagination
  const filteredItems = records.filter((r) =>
    `${r.employee_id}${r.employee_name}${r.department_name}${r.attn_date}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentData = filteredItems.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  return (
    <div className="container-fluid mt-4">
      <ToastContainer />

      {/* 🔹 Filter Form */}
      <div className="card shadow-sm mb-4">
        <div className="card-header with-elements">
          <span className="card-header-title me-2">Date-Wise Attendance</span>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row g-3 align-items-end">
              {/* From Date */}
              <div className="col-md-2">
                <label>From Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="start_date"
                  value={filters.start_date}
                  onChange={handleInput}
                  required
                />
              </div>

              {/* To Date */}
              <div className="col-md-2">
                <label>To Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="end_date"
                  value={filters.end_date}
                  onChange={handleInput}
                  required
                />
              </div>

              {/* Department */}
              <div className="col-md-3">
                <label>Department</label>
                <Select
    name="dept_id"
    
    value={
      departments
        .map((dept) => ({
          value: dept.department_id || dept.id,
          label: dept.department_name,
        }))
        .find((d) => d.value === filters.dept_id) || null
    }
    onChange={(selected) =>
      handleInput({
        target: {
          name: "dept_id",
          value: selected ? selected.value : "0",  // same as All Department
        },
      })
    }
    options={departments.map((dept) => ({
      value: dept.department_id || dept.id,
      label: dept.department_name,
    }))}
    isClearable
    placeholder="All Department"
    className="basic-single"
  />
              </div>

              {/* Employee */}
              <div className="col-md-3">
                <label>Employee</label>
                <select
                  className="form-control"
                  name="employee_id"
                  value={filters.employee_id}
                  onChange={handleInput}
                >
                  <option value="0">All Employees</option>
                  {employees.map((e) => (
                    <option key={e.employee_id || e.id} value={e.employee_id || e.id}>
                      {e.first_name} {e.last_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Action */}
             

              {/* Submit */}
              <div className="col-md-2">
                <button type="submit" className="btn btn-primary w-100">
                  Get
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* 🔹 Data Table */}
      <div className="card">
        <h6 className="card-header text-primary">Attendance History</h6>
        <div className="card-body">
          {/* Top Controls */}
          <div className="d-flex justify-content-between mb-3 align-items-center">
            <div className="d-flex align-items-center gap-2">
              <DownloadButtons data={filteredItems} filename="Attendance_History" />
              <EntriesSelector
                setEntriesPerPage={setEntriesPerPage}
                setCurrentPage={setCurrentPage}
              />
            </div>

            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Search..."
              style={{ width: "200px" }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {/* Table */}
          {loading ? (
            <div className="d-flex justify-content-center p-5">
              <div className="spinner"></div>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead style={{ backgroundColor: "#7d858369" }}>
                  <tr>
                    <th>Employee ID</th>
                    <th>Employee Name</th>
                    <th>Department</th>
                    <th>Attendance Date</th>
                    <th>Attendance History</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.length > 0 ? (
                    currentData.map((row, idx) => (
                      <tr key={idx}>
                        <td>{row.employee_id}</td>
                        <td>{row.employee_name}</td>
                        <td>{row.department_name}</td>
                        <td>{row.attn_date}</td>
                        <td>{row.attn_history}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center text-danger fw-bold">
                        No records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default AttendanceHistoryReport;
